// @LTG-ID: F-002
// @STATUS: BUILT
// @HERMETIC: true
// @DOCS: 08_FEATURES.md#F-002, source Landing Page.html lines 1232-1282, 10_DECISIONS.md#ADR-006
// @CHANGED: 2026-02 session_002
// @OWNER: web

import { useEffect, useState } from "react";
import ExternalCTA from "../../lib/external-cta";
import "./page-nav.css";

const SECTIONS = [
    { id: "sectors", label: "Sectors" },
    { id: "archetype", label: "Your fit" },
    { id: "snapshot", label: "Calculator" },
    { id: "levers", label: "Levers" },
    { id: "exit", label: "Readiness" },
    { id: "engage", label: "Pricing" },
    // CHG-0107.2 — "Refunds" tab removed; target section <RefundDisclosure /> unmounted from Home.jsx
    { id: "owner-questions", label: "Q&A" },
    { id: "journals", label: "Journals" },
];

export function PageNav() {
    const [active, setActive] = useState("");

    useEffect(() => {
        function onScroll() {
            for (let i = SECTIONS.length - 1; i >= 0; i--) {
                const el = document.getElementById(SECTIONS[i].id);
                if (!el) continue;
                const rect = el.getBoundingClientRect();
                if (rect.top <= 200) {
                    setActive(SECTIONS[i].id);
                    return;
                }
            }
            setActive("");
        }
        window.addEventListener("scroll", onScroll, { passive: true });
        onScroll();
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <nav
            className="ltg-page-nav"
            aria-label="Page sections"
            data-testid="page-nav"
        >
            <div className="ltg-page-nav__inner">
                <span className="ltg-page-nav__label">On this page</span>
                <div
                    className="ltg-page-nav__tabs-wrap"
                    data-testid="page-nav-tabs-wrap"
                >
                    <div className="ltg-page-nav__tabs">
                        {SECTIONS.map((s) => (
                            <a
                                key={s.id}
                                href={`#${s.id}`}
                                data-cta-id={`page-nav-${s.id}`}
                                data-testid={`page-nav-${s.id}`}
                                className={`ltg-page-nav__tab ${active === s.id ? "is-active" : ""}`}
                                aria-current={
                                    active === s.id ? "true" : undefined
                                }
                            >
                                {s.label}
                            </a>
                        ))}
                    </div>
                    <span
                        className="ltg-page-nav__fade"
                        aria-hidden="true"
                    />
                </div>
                <ExternalCTA
                    ctaId="page-nav-order"
                    className="ltg-page-nav__cta"
                >
                    Get Your Valuation{" "}
                    <span className="ltg-arrow" aria-hidden="true">
                        &rarr;
                    </span>
                </ExternalCTA>
            </div>
        </nav>
    );
}

export default PageNav;
